import React, { Component } from 'react';
import { bool, func, number } from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import UTModal from 'app/components/UTModal';
import { actionCreators as authActions } from 'redux/authHandlers';
import { CHANGE_PRIMARY_EMAIL, VALIDATE_CHANGE_PRIMARY_EMAIL } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';

import { steps } from './constants';
import styles from './styles';

class ChangePrimaryEmail extends Component {
  state = { newEmail: undefined };

  handleFinishFlow = () => {
    this.props.onCloseModal();

    // To avoid showing step one when modal transition is closing
    setTimeout(() => this.props.dispatch(authActions.updateChangePrimaryEmailStep(1)), 200);
  };

  handleSendEmail = () => this.props.dispatch(submit(CHANGE_PRIMARY_EMAIL));

  handleSendEmailSubmit = values => {
    this.props.dispatch(authActions.changePrimaryEmail(values.email));
    this.setState({ newEmail: values.email });
  };

  handleValidateEmail = () => this.props.dispatch(submit(VALIDATE_CHANGE_PRIMARY_EMAIL));

  handleValidateEmailSubmit = values =>
    this.props.dispatch(authActions.validateChangeEmail(this.state.newEmail, values.code));

  childProps = () => {
    switch (this.props.currentStep) {
      case 1: {
        return {
          acceptButton: { onPress: this.handleSendEmail, text: message('Commons:accept') },
          title: message('Configuration:changePrimaryEmailTitle'),
          onSubmit: this.handleSendEmailSubmit,
          loading: this.props.changePrimaryEmailLoading
        };
      }
      case 2: {
        return {
          acceptButton: { onPress: this.handleValidateEmail, text: message('Commons:accept') },
          title: message('Configuration:changePrimaryEmailTitle'),
          onSubmit: this.handleValidateEmailSubmit,
          loading: this.props.changePrimaryEmailLoading || this.props.validateEmailLoading,
          newEmail: this.state.newEmail
        };
      }
      default: {
        return {};
      }
    }
  };

  render() {
    const StepComponent = steps.find(elem => elem.stepNumber === this.props.currentStep).component;
    const stepProps = this.childProps();
    return (
      <div style={styles.modalContainer}>
        <UTModal
          isOpen={this.props.modalIsOpen}
          onRequestClose={this.handleFinishFlow}
          cancelButton={
            !this.props.validateEmailLoading &&
            !this.props.changePrimaryEmailLoading && {
              onPress: this.handleFinishFlow,
              text: message('Commons:cancel')
            }
          }
          acceptButton={
            !this.props.validateEmailLoading &&
            !this.props.changePrimaryEmailLoading &&
            stepProps.acceptButton
          }
          title={stepProps.title}
        >
          <StepComponent {...this.childProps()} />
        </UTModal>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  currentStep: store.auth.changePrimaryEmailStep,
  changePrimaryEmailLoading: store.auth.changePrimaryEmailLoading,
  validateEmailLoading: store.auth.validateEmailLoading
});

ChangePrimaryEmail.propTypes = {
  modalIsOpen: bool,
  changePrimaryEmailLoading: bool,
  validateEmailLoading: bool,
  onCloseModal: func,
  currentStep: number
};

export default connect(mapStateToProps)(ChangePrimaryEmail);
